<template>
  <div class="rqa_attachment">
    <p v-if="loading" class="rqa_attachment_note">טוען צילום מסך…</p>
    <p v-else-if="failed" class="rqa_attachment_note">
      לא הצלחנו להציג את צילום המסך.
      <a href="#" @click.prevent="load">נסי שוב</a>
    </p>
    <button v-else-if="src" type="button" class="rqa_attachment_button" :aria-label="expanded ? 'הקטנת צילום המסך' : 'הגדלת צילום המסך'" @click="expanded = !expanded">
      <img :src="src" alt="צילום מסך שצורף לשאלה" class="rqa_attachment_img" :class="{ rqa_attachment_img_expanded: expanded }">
    </button>
  </div>
</template>
<script>
// Jira 8dce4932: the screenshot a recruiter attached to a question. The bytes are fetched
// lazily through the authenticated endpoint (an <img> URL could not carry the admin headers).
import { getAttachment, adminAttachment, attachmentDataUrl } from '@/services/recruiterQaApi'

export default {
  name: 'RecruiterQaAttachment',
  props: {
    questionId: { type: Number, required: true },
    // true in the supervisor console (reads any tenant question), false for the owner.
    supervisor: { type: Boolean, default: false }
  },
  data () {
    return { src: '', loading: false, failed: false, expanded: false }
  },
  watch: {
    questionId () { this.load() }
  },
  mounted () { this.load() },
  methods: {
    async load () {
      const id = this.questionId
      this.loading = true
      this.failed = false
      try {
        const att = await (this.supervisor ? adminAttachment(id) : getAttachment(id))
        if (id !== this.questionId) return
        this.src = attachmentDataUrl(att)
        this.failed = !this.src
      } catch (e) {
        if (id !== this.questionId) return
        this.src = ''
        this.failed = true
      } finally {
        if (id === this.questionId) this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.rqa_attachment {
  margin: 4px 0 6px;
}
.rqa_attachment_note {
  font-size: 12px;
  color: #888;
  margin: 0;
}
.rqa_attachment_button {
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 2px;
  cursor: zoom-in;
  max-width: 100%;
}
.rqa_attachment_img {
  display: block;
  max-width: 100%;
  max-height: 160px;
  border-radius: 4px;
}
.rqa_attachment_img_expanded {
  max-height: none;
  cursor: zoom-out;
}
</style>
